import React, { useState } from "react";
import "../styles/App.css"; // Import global styles
import { SERVER_URL } from "../config";

const CreateClinic: React.FC = () => {
  const [formData, setFormData] = useState({
    clinicName: "",
    address: "",
    phone: "",
    region: "",
    city: "",
    zip: "",
  });
  const [message, setMessage] = useState("");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await fetch(`${SERVER_URL}/api/clinic/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      if (response.ok) {
        setMessage("Clinic created successfully!");
        setFormData({
          clinicName: "",
          address: "",
          phone: "",
          region: "",
          city: "",
          zip: "",
        });
      } else {
        setMessage(data.error || "Failed to create clinic.");
      }
    } catch (error) {
      setMessage("An error occurred while creating the clinic.");
    }
  };

  return (
    <div className="clinic-container">
      <h2>Create Clinic</h2>
      {message && <p className="message">{message}</p>}
      <form onSubmit={handleSubmit} className="clinic-form">
        <label>Clinic Name</label>
        <input
          type="text"
          name="clinicName"
          value={formData.clinicName}
          onChange={handleChange}
          required
        />

        <label>Address</label>
        <input
          type="text"
          name="address"
          value={formData.address}
          onChange={handleChange}
        />

        <label>City</label>
        <input
          type="text"
          name="city"
          value={formData.city}
          onChange={handleChange}
        />

        <label>ZIP Code</label>
        <input
          type="text"
          name="zip"
          value={formData.zip}
          onChange={handleChange}
        />

        <label>Phone</label>
        <input
          type="text"
          name="phone"
          value={formData.phone}
          onChange={handleChange}
        />

        <label>Region</label>
        <input
          type="text"
          name="region"
          value={formData.region}
          onChange={handleChange}
          required
        />

        <button type="submit">Create Clinic</button>
      </form>
    </div>
  );
};

export default CreateClinic;
